import script from "./full-loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./full-loading.vue?vue&type=script&setup=true&lang=ts"

import "./full-loading.vue?vue&type=style&index=0&id=41ba61aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41ba61aa"]])

export default __exports__